const units = {}

// === IMPORT LOCALLY-SCOPED JOBS === //
//import games from "@frog/source/data/games/index.js"
// Object.values(games).forEach((game) => {
//     if(game.localJobs != undefined) {
//         game.localJobs.forEach((job) => {units[game.slug + job.jobKey] = job})
//     }
// })
import pirateJobs from "@frog/source/data/games/pirates/unit-jobs.js"
Object.values(pirateJobs).forEach((job) => {
    units["pirates/" + job.jobKey] = job
})
import heroJobs from "@frog/source/data/games/hero/unit-jobs.js"
Object.keys(heroJobs).forEach((jobKey) => {
    units[jobKey] = heroJobs[jobKey]
})

/////////////
// RANGER //
///////////

units["dagger"] = {
    "jobKey": "dagger",
    "jobName": "Thief",
    "fequivalent": "Thief",
    "maxhealth": 20,
    "moverange": 2,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Daggers",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "daggers",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against axes and guns.",
    ]
}

units["bow"] = {
    "jobKey": "bow",
    "jobName": "Archer",
    "fequivalent": "Archer",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against swords and daggers.",
    ]
}

units["gun"] = {
    "jobKey": "gun",
    "jobName": "Gunman",
    "fequivalent": "Pirate",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Gun",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "gun",
    },

    "facts": [
        "Attacks from 2 tiles away. Strong against spears and bows.",
    ]
}

/////////////////////
// RANGER MOUNTED //
///////////////////

units["bowcavalier"] = {
    "jobKey": "bowcavalier",
    "jobName": "Bowcavalier",
    "fequivalent": "Nomad",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Bow",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "bow",
    },
}
// TODO: daggerhorse?
// TODO: gunhorse?

//////////////
// FIGHTER //
////////////

units["sword"] = {
    "jobKey": "sword",
    "jobName": "Swordsman",
    "fequivalent": "Mercenary",
    "attacktype": "steel",
    "moverange": 2,
    "maxhealth": 20,
    "power": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },

    "facts": [
        "Strong against spears and bows.",
    ]
}

units["spear"] = {
    "jobKey": "spear",
    "jobName": "Spearman",
    "fequivalent": "Soldier",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },

    "facts": [
        "Strong against axes and guns.",
    ]
}

units["hammer"] = {
    "jobKey": "hammer",
    "jobName": "Axeman",
    "fequivalent": "Fighter",
    "attackrange": 1,
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "hammer",
    },

    "facts": [
        "Strong against spears and bows.",
    ]
}

//////////////////////
// FIGHTER MOUNTED //
////////////////////

units["swordcavalier"] = {
    "jobKey": "swordcavalier",
    "jobName": "Swordcavalier",
    "fequivalent": "Cavalier",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "decalImageKey": "red-helmet",

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },
}

units["spearcavalier"] = {
    "jobKey": "spearcavalier",
    "jobName": "Spearcavalier",
    "fequivalent": "Paladin",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "decalImageKey": "blue-helmet",

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },
}

units["hammercavalier"] = {
    "jobKey": "hammercavalier",
    "jobName": "Axecavalier", // ??
    "fequivalent": "Warlord",
    "moverange": 3,
    "movetype": "mounted",
    "moveaudio": "Unit:Move:Horse",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "decalImageKey": "green-helmet",

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "hammer",
    },
}

//////////////////////
// FIGHTER ARMORED //
////////////////////

units["swordknight"] = {
    "jobKey": "swordknight",
    "jobName": "Swordknight",
    "fequivalent": "Swordknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    // "attackspeed": 5,
    // "luck": 0,
    "decalImageKey": "red-shield",

    "primaryItem": {
        "name": "Sword",
        "element": "fire",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "sword",
    },
}

units["spearknight"] = {
    "jobKey": "spearknight",
    "jobName": "Spearknight",
    "fequivalent": "Lancerknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "decalImageKey": "blue-shield",

    "primaryItem": {
        "name": "Spear",
        "element": "water",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "spear",
    },
}

units["hammerknight"] = {
    "jobKey": "hammerknight",
    "jobName": "Axeknight", // ??
    "fequivalent": "Hammerknight",
    "moverange": 1,
    "movetype": "armored",
    "moveaudio": "Unit:Move:Armored",
    "maxarmor": 10,
    "armortype": "steel",
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,
    "decalImageKey": "green-shield",
    "weaponImageKey": "hammer",

    "primaryItem": {
        "name": "Axe",
        "element": "earth",
        "attacktype": "steel",
        "attackrange": 1,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "hammer",
    },
}

///////////
// MAGE //
/////////

units["mage"] = {
    "jobKey": "mage",
    "jobName": "Mage",
    "fequivalent": "Mage",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Red Staff",
        "element": "fire",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "red-staff"
    },
}

units["priest"] = {
    "jobKey": "priest",
    "jobName": "Priest",
    "fequivalent": "Priest",
    "skills": ["restore-health"],
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Blue Staff",
        "element": "water",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "blue-staff",
    },
}

units["shaman"] = {
    "jobKey": "shaman",
    "jobName": "Shaman",
    "fequivalent": "Shaman",
    "moverange": 2,
    "maxhealth": 20,
    "defense": 0,
    "resistance": 0,

    "primaryItem": {
        "name": "Green Staff",
        "element": "earth",
        "attacktype": "magic",
        "attackrange": 2,
        "power": 20,
        "skillKeys": ["inflict-damage"],
        "weaponImageKey": "green-staff",
    },
}

export default units
